import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { __ } from '@wordpress/i18n';

// Config.
import { FILTERS_SHAPE } from '@/config/prop-types';
import tabs from '@/config/tabs';

// Services.
import getFilterUrl from '@/services/filters/get-filter-url';
import modifyFilters from '@/services/filters/modify-filters';

const Tabs = ({ filters }) => {
  const tabComponents = [];
  for (const [tabIndex, tab] of tabs) {
    tabComponents.push(
      <li role="tab" className={classnames('hst-tabs__tab', { 'hst-tabs__tab--active': filters.tab === tabIndex })}>
        <Link to={getFilterUrl(modifyFilters(filters, 'set', 'tab', tabIndex))}>
          {tab}
        </Link>
      </li>,
    );
  }

  return (
    <ol
      aria-label={__('Primary Navigation', 'hst')}
      className="hst-tabs"
      role="tablist"
    >
      {tabComponents}
    </ol>
  );
};

Tabs.propTypes = {
  filters: PropTypes.shape(FILTERS_SHAPE).isRequired,
};

export default Tabs;
